import React, { useState } from "react";
import Modal from "./Modal";

export function Cards({ htext, ptext, img1, btext, ialt, modalContent }) {
  const [show, setShow] = useState(false);
  const [modalPos, setModalPos] = useState({ top: 0, left: 0 });

  const openModal = (e) => {
    const rect = e.target.getBoundingClientRect();

    setModalPos({
      top: rect.top + window.scrollY + rect.height,
      left: rect.left + window.scrollX
    });

    setShow(true);
  };

  return (
    <>
      <div className="card">
        <img src={img1} alt={ialt} />
        <h3>{htext}</h3>
        <p>{ptext}</p>

        <button className="btn btn-primary" onClick={openModal}>
          {btext}
        </button>
      </div>

      <Modal
        show={show}
        onClose={() => setShow(false)}
        title={htext}
        content={modalContent}
        position={modalPos}
      />
    </>
  );
}
